import './AgentChatPrompt.css'
import { forwardRef, useImperativeHandle, useRef, type Dispatch, type KeyboardEvent, type SetStateAction } from 'react'
import { TextArea } from '@/components/scalar/TextArea'

export type AgentChatPromptHandle = {
  focus: () => void
}

type Props = {
  value: string
  setValue: Dispatch<SetStateAction<string>>
  disabled?: boolean
  onSend: () => void
}

export const AgentChatPrompt = forwardRef<AgentChatPromptHandle, Props>(
  function AgentChatPrompt({ value, setValue, disabled, onSend }, ref) {
    const promptRowRef = useRef<HTMLDivElement>(null)

    useImperativeHandle(ref, () => ({
      focus() {
        promptRowRef.current?.querySelector('textarea')?.focus()
      },
    }))

    //--------------------------------------------------------------------------------
    function handlePromptKeyDown(ev: KeyboardEvent<HTMLTextAreaElement>) {
      if (ev.key !== 'Enter') return
      if (ev.shiftKey || ev.ctrlKey) return
      ev.preventDefault()
      onSend()
    }

    //--------------------------------------------------------------------------------
    return (
      <div className='AgentChatPrompt' ref={promptRowRef}>
        <TextArea
          label='Prompt'
          value={value}
          setValue={setValue}
          autoHeight
          height={200}
          disabled={disabled}
          onKeyDown={handlePromptKeyDown}
        />
      </div>
    )
  },
)
